export default __webpack_public_path__ + "static/media/new-delete.29a42c97.svg";